import { Fragment } from "react";
import "./video_feature.scss";

import LoaderPopUp from "../../../../components/loader/loader";
import Sidebar from "../../../../components/Sidebar/Sidebar";

///////////////////Desktop
import HeaderComponent from "../../structure_components/desktop_screens/header_component/header_component";

///////Mobile////////////////////
import MobileRightSideBarComponent from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import VideoFeatureContentComponent from "./video_feature_content_component/video_feature_content_component";

//Redux
import { connect } from "react-redux";

const VideoFeature = (props) => {
  let { loader, videoData, history, userData, userPreference } = props;
  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Fragment>
      <div className="video_feature_wrapper">
        <Sidebar />
        <div className="video_feature_main">
          {isMob() ? (
            <Fragment>
              <MobileRightSideBarComponent history={history} />
              <VideoFeatureContentComponent
                videoData={videoData}
                userData={userData}
                history={history}
                userPreference={userPreference}
              />
            </Fragment>
          ) : (
            <Fragment>
              <HeaderComponent history={history} />
              <VideoFeatureContentComponent
                videoData={videoData}
                userData={userData}
                history={history}
                userPreference={userPreference}
              />
            </Fragment>
          )}
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    videoData: state.userActivity.videoData,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(VideoFeature);
